import * as React from "react";
import { enableRefresh } from "../../utils/jsBridge";
import SmallLoading from "../../components/SmallLoading";
import { RollOverContainer, RollOverBox } from "./styles.index";
class SlideProductGroup extends React.Component {
    constructor(props) {
        super(props);
        this.touchDiv = React.createRef();
        this.onTouchMove = (e) => {
            var _a, _b;
            if (!((_a = this.state.dragPoints) === null || _a === void 0 ? void 0 : _a.startPoint)) {
                return;
            }
            const { startPoint } = this.state.dragPoints;
            const touchTargetWrap = (_b = this.touchDiv) === null || _b === void 0 ? void 0 : _b.current;
            const touchTarget = touchTargetWrap === null || touchTargetWrap === void 0 ? void 0 : touchTargetWrap.children[0];
            if (!touchTarget) {
                return;
            }
            const productsNum = touchTarget.children.length;
            const parentScrollLeft = touchTarget.scrollLeft;
            const middleProduct = touchTarget.children[productsNum - 1];
            const middleProductLeft = middleProduct ? middleProduct.offsetLeft / 2 : undefined;
            if (middleProductLeft !== undefined && parentScrollLeft >= middleProductLeft) {
                this.props.onLoadMoreContent();
            }
            if (this.isDragging) {
                const touch = e.touches[0];
                const endPoint = {
                    x: touch.clientX,
                    y: touch.clientY,
                };
                const a = Math.abs(endPoint.x - startPoint.x);
                const b = Math.abs(endPoint.y - startPoint.y);
                if (endPoint.y - startPoint.y > 0 &&
                    Math.abs((Math.atan2(b, a) * 180) / Math.PI) >= 60) {
                    enableRefresh({ refresh: true });
                }
            }
        };
        this.onTouchStart = (e) => {
            const touch = e.touches[0];
            const dragPoints = {
                startPoint: {
                    x: touch.clientX,
                    y: touch.clientY,
                },
            };
            this.setState({ dragPoints });
            enableRefresh({ refresh: false });
        };
        this.onTouchEnd = () => {
            enableRefresh({ refresh: true });
        };
        this.state = {
            dragPoints: null,
        };
    }
    get isDragging() {
        return this.state.dragPoints !== null;
    }
    render() {
        const { isLoading, isValid = true, gridGap, parentGap } = this.props;
        return (React.createElement(RollOverBox, { ref: this.touchDiv, onTouchMove: this.onTouchMove, onTouchStart: this.onTouchStart, onTouchEnd: this.onTouchEnd }, isLoading || isValid ? (React.createElement(RollOverContainer, { gridGap: gridGap, parentGap: parentGap }, isLoading ? React.createElement(SmallLoading, null) : this.props.children)) : null));
    }
}
export default SlideProductGroup;
